// extracted by mini-css-extract-plugin
module.exports = {"container":"CumulativeDonationsSkeleton_container__S5y5V","graph":"CumulativeDonationsSkeleton_graph__6Nyru","shimmer":"CumulativeDonationsSkeleton_shimmer__BwutT"};